import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE,
  UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_PENDING,
  UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_SUCCESS,
  UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_FAILURE
} from '../actionTypes';

const updateDataUltimoAcessoConta = async (id) => {
  return httpService.putApiManager(`/clienteAgrare/updateDataUltimoAcesso/${id}`, null);
}

function* sagaUpdateDataUltimoAcessoContaAgrare(action) {
  yield put({ type: UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_PENDING });

  try {
    const registro = yield call(updateDataUltimoAcessoConta, action.id);
    yield put({ type: UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_SUCCESS, registro });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchUpdateDataUltimoAcessoContaAgrare() {
  yield takeLatest(UPDATE_DATA_ULT_ACESSO_CONTA_AGRARE, sagaUpdateDataUltimoAcessoContaAgrare);
}
